import { Box, Collapsible, Link, TextProps } from "@biblioteksentralen/react";
import { getErrorMessage } from "@libry-content/common";
import { useTranslation } from "../../utils/hooks/useTranslation";
import { ChevronDown } from "react-feather";

type Props = TextProps & {
  error?: unknown;
  customErrorMessage?: string;
};

export const Feilmelding = ({ error, customErrorMessage, ...textProps }: Props) => {
  const { t } = useTranslation();
  const errorMessage = getErrorMessage(error);
  if (errorMessage) console.error(errorMessage);

  if (!errorMessage) return null;

  return (
    <Box role="alert" color="red.500" {...textProps}>
      <Box fontWeight={600}>{customErrorMessage ?? t("Beklager, det oppsto en ukjent feil.")}</Box>
      <Box fontSize="xs">
        <Collapsible.Root>
          <Collapsible.Trigger>
            <Link variant="plain" as="div" display="flex" gap="0.25rem">
              {t("Utviklerinformasjon")} <ChevronDown />
            </Link>
          </Collapsible.Trigger>
          <Collapsible.Content maxWidth="20rem">{errorMessage}</Collapsible.Content>
        </Collapsible.Root>
      </Box>
    </Box>
  );
};
